import { MESSAGE_CHANNEL } from "../../../packages/constants";
import { chatActions, chatProvider, typeGuards } from "../../chat";
import type { AppStore } from "../../../store";
import type { GetMessagesResponse } from "../../chat/types";

const { updateFileMessage } = chatActions;
const { getMessagesData } = chatProvider;
const { isMessageFile } = typeGuards;

export const updateMessageFileHandler = (
  storeAPI: AppStore,
  msg: GetMessagesResponse["data"]
) => {
  if (msg) {
    const messages = getMessagesData(msg.messages, MESSAGE_CHANNEL.SSE);
    const message = messages[messages.length - 1];

    if (isMessageFile(message)) {
      storeAPI.dispatch(updateFileMessage(message));
    }
  }
};
